import React, { useMemo, useState, useEffect } from 'react';

import { getMoment } from '@libs/NwMoment';
import { getTodayISO, toISODate } from '@libs/NwMoment';

import { useStateValue } from '@contexts/StateProvider';

import { onGetOrderedEventList, useProject } from '@hooks/API/Project/UseProject';

import BookingEvent from '@components/EventsBoxes/BookingEvent';
import NonBookingEvent from '@components/EventsBoxes/NonBookingEvent';
import NwDivider from '@components/Gui/NwDivider';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ProjectEventsOverview = ({ projectId, onMoveToEvent }) => {
    const [{ areaContext }] = useStateValue();

    const [projectEvents, setProjectEvents] = useState([]);

    const { data: currentProject, isFetching } = useProject(projectId);

    useEffect(() => {
        if (!isFetching && currentProject) {
            const te = onGetOrderedEventList(currentProject, areaContext, true, true);
            setProjectEvents(te);
        }
    }, [currentProject, isFetching]);

    const handleSelectEvent = (eventdata) => {
        let evid = 0;
        if (eventdata.ID) {
            evid = eventdata.ID;
        } else {
            evid = eventdata.GroupedEventIDs[0];
        }
        onMoveToEvent(evid, eventdata.elType);
    };

    const renderDisplayEvent = (event) => {
        switch (event.elType.toLowerCase()) {
            case 'event':
                return <BookingEvent event={event} page="project" onSelectEvent={handleSelectEvent} />;
            default:
                return <NonBookingEvent event={event} page="project" onSelectEvent={handleSelectEvent} />;
        }
    };

    const { pastEvents, nextEvents } = useMemo(() => {
        let pastEvents = [];
        let nextEvents = [];
        if (projectEvents) {
            pastEvents = projectEvents.filter((event) => toISODate(event.sortField) < getTodayISO()).reverse();
            nextEvents = projectEvents.filter((event) => toISODate(event.sortField) >= getTodayISO());
        }
        return { pastEvents, nextEvents };
    }, [projectEvents]);

    const renderEvents = (events) => {
        return (
            <>
                {events.map((event, index) => {
                    const eventWithType = { ...event, type: event.elType.toLowerCase() };
                    return (
                        <div style={{ width: '100%' }} key={index}>
                            {renderDisplayEvent(eventWithType)}
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <div className="internal-card">
            <div className="header">
                <div className="title-container">
                    <NwIcon className="icon" icon={byPrefixAndName.fasl['calendar-alt']} />
                    <div className="title">Events</div>
                </div>
            </div>
            {}
            <div className="content">
                {nextEvents.length > 0 && (
                    <>
                        <NwDivider dark textSize="medium">
                            Next and Current Events
                        </NwDivider>
                        {renderEvents(nextEvents)}
                    </>
                )}
                {pastEvents.length > 0 && (
                    <>
                        <NwDivider dark textSize="medium">
                            Past Events (newer to older)
                        </NwDivider>
                        {renderEvents(pastEvents)}
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjectEventsOverview;
